import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getRoles = actionFactory(types.GET_ROLES);
export const createRole = actionFactory(types.CREATE_ROLE);
export const updateRole = actionFactory(types.UPDATE_ROLE);
export const deleteRole = actionFactory(types.DELETE_ROLE);
export const getPermissions = actionFactory(types.GET_PERMISSIONS);
export const getRoleTypes = actionFactory(types.GET_ROLE_TYPES);
